import { Outlet } from "react-router-dom";
import styles from "./Auth.module.scss";
import classNames from "classnames/bind";
const cx = classNames.bind(styles);

const Auth = () => {
  return (
    <div className={cx("auth-container")}>
      <div className={cx("auth-container-left")}>
        <img
          src={require("~/assets/images/logo.jpg")}
          alt="Logo"
          className={cx("auth-container-left-logo")}
        />
      </div>
      <div className={cx("auth-container-right")}>
        {/* Cube 1 - bottom left of form */}
        <div className={cx("cube", "cube-1")} />
        {/* Cube 2 - top right of form */}
        <div className={cx("cube", "cube-2")} />
        {/* Cube 3 - bottom right of form */}
        <div className={cx("cube", "cube-3")} />
        <div className={cx("auth-form-content")}>
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Auth;
